import { createFeatureSelector } from '@ngrx/store';
import { DialogsState } from './dialogs.state';

/**
 * Feature-Key für den Dialogs-State.
 */
export const DIALOGS_FEATURE_KEY = 'dialogs';

/**
 * Feature-Selector für den gruppierten Dialogs-State.
 * Wird von den einzelnen Dialog-Selectors als Basis verwendet.
 */
export const selectDialogs = createFeatureSelector<DialogsState>(DIALOGS_FEATURE_KEY);
